import setPopoutChildState from '../actions/setPopoutChildState';
import { mutator } from 'satcheljs';
import { getStore } from '../store/childStore';

mutator(setPopoutChildState, actionMessage => {
    getStore().state = actionMessage.state;
});
